import axios from 'axios'
import { UpdateProjectResponse } from '../../types/project'

export const updateProject = async (
  projectId: number,
  name: string
): Promise<UpdateProjectResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const formData = new FormData()
    formData.append('project_id', projectId.toString())
    formData.append('name', name)

    const response = await axios.put(
      `${backendUrl}/n8n/mavis/projects`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return (response.data as unknown) as UpdateProjectResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
